module.exports = __webpack_public_path__ + "img/7_54.95de9463.png";